import styled from 'styled-components'
import COLORS from '@colors'

export const Container = styled.div`
  position: absolute;
  top: 64px;
  height: calc(100% - 64px);
  right: 0px;
  width: 300px;
  background-color: rgba(255, 255, 255, 0.9);
  transition: 0.3s ease;
  overflow: hidden;
  ${({ drawing }) => drawing && 'visibility:hidden'};
`

export const Header = styled.div`
  display: flex;
  justify-content: flex-end;
  height: 40px;
  padding: 16px;
`

export const IconWrapper = styled.div`
  cursor: pointer;
  user-select: none;
  ${props => props.disabled && 'opacity: 0.5;'}
`

export const Row = styled.div`
  display: flex;
  padding: 7px;
  border: 1px solid transparent;
  align-items: ${({ alignItems }) => alignItems || 'start'};
  width: calc(${({ width }) => width || '100%'} - 2px);
  height: ${({ height }) => height || '33.33%'};
  ${({ inner }) => inner && 'padding-top: 0px;'};
  ${({ justify }) => justify && `justify-content:${justify}`}
  ${({ firstLevel }) =>
    firstLevel &&
    `
    box-sizing: border-box;
    cursor: pointer;
    height: 111px;
    border-bottom: 1px solid ${COLORS.whiteD}; 
    :hover {
      border: 1px solid ${COLORS.leather};
      border-radius: 4px;
    }`};
  flex-direction: ${({ flexDirection }) => flexDirection || 'row'};
  p {
    font: 500 14px/17px Barlow;
    ${({ color }) => color && `color: ${color}`};
    ${({ hideOverflow }) =>
      hideOverflow &&
      `
        white-space: nowrap;
        text-overflow: ellipsis;
        display: block;
       overflow: hidden
      `};
  }
`

export const Body = styled.div`
  width: 100%;
  height: 100%;
`

export const Col = styled.div`
  ${({ justify }) => justify && `justify-content: ${justify}`}
  width: ${({ width }) => (width ? width : '33.33%')};
  height: ${({ height }) => (height ? height : '100%')};
  overflow-x: hidden;
  text-overflow: ellipsis;
  padding-bottom: ${({ inner }) => !inner && '4px'};
  display: flex;
  flex-direction: ${({ flexDirection }) => flexDirection || 'column'};
  align-items: start;
  font: 400 14px/17px Barlow;
`

export const Pill = styled.div`
  border: 0;
  border-radius: 4px;
  height: 21px;
  min-width: 54px;
  position: relative;
  box-sizing: border-box;
  font: 400 12px/14px Barlow;
  letter-spacing: 0;
  color: ${COLORS.gray87};
  background-color: ${({ status }) =>
    (status && 'transparent') || COLORS.grayE8};
  outline: 0;
  padding: 3px 8px;
  text-transform: uppercase;
  margin-right: 5px;
  text-align: center;
  div {
    display: inline-block !important;
  }
`

export const Scroll = styled.div`
  overflow-y: scroll;
  height: 100%;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: ${COLORS.whiteF3};
  }

  &::-webkit-scrollbar-thumb {
    background: ${COLORS.whiteD};
  }
`
